module.exports = __webpack_public_path__ + "static/img/activity_sdy_02-2.fcd4ea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_02-2.jpg
// module id = Io1p
// module chunks = 0